const NAME = "QUERY_DEFINITION_PARAMETERS_PAGE";

export default NAME;
